import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,

    Box,
    Grid,
    Button,
    Tooltip,
    IconButton,
    Typography,
} from "@material-ui/core";
import {
    X as XIcon
} from "react-feather";
import moment from "moment";
import urls from "../../../../../constant/urls";
import {getUrlForImageMobileUrl} from "../../../../../helpers/urlStaticFiles";

const DialogImageNotification = (props) => {
    const { isOpen, notification, onClose } = props;

    return (
        <Dialog
            open={isOpen}
            onClose
            fullScreen
        >

            <DialogTitle>
                <Grid container alignItems="center" justify="space-between">
                    <Grid item>
                        <Grid container spacing={1} alignItems="flex-end">
                            <Grid item>
                                <Box mb={1}>
                                    <Typography variant="h3">{notification?.payload?.item?.license_plate || 'Ожидание'}</Typography>
                                </Box>

                                {
                                    Object.keys(notification).length > 0 && (
                                        <Typography variant="h5">{notification?.payload?.item?.comment}</Typography>
                                    )
                                }
                            </Grid>
                            <Grid item>
                                {
                                    Object.keys(notification).length > 0 && (
                                        <Typography variant="h5" style={{color: '#546e7a'}}>({moment(notification?.payload?.item?.created).format('DD.MM.YYYY HH:mm:ss')})</Typography>
                                    )
                                }
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item>
                        <Tooltip title="Выйти из полноэкранного режима">
                            <IconButton onClick={onClose}>
                                <XIcon/>
                            </IconButton>
                        </Tooltip>
                    </Grid>
                </Grid>
            </DialogTitle>

            <DialogContent style={{display: 'flex', flexDirection: 'column'}}>

                {
                    Boolean(Object.keys(notification).length > 0) ? (
                        <Content {...notification}/>
                    ) : (
                        <EmptyContent/>
                    )
                }

            </DialogContent>

            <DialogActions>
                <Box px={2} width="100%">
                    <Grid container spacing={2}>
                        <Grid item>
                            <Button variant="outlined" onClick={onClose}>Выйти из полноэкранного режима</Button>
                        </Grid>
                    </Grid>
                </Box>
            </DialogActions>

        </Dialog>
    )
}

const EmptyContent = () => {
    return (
        <Box flex="1" display="flex" justifyContent="center" alignItems="center">
            <svg width="645" height="645" viewBox="0 0 645 645" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M295.399 546.939H302.309V507.111H319.445V501.047H278.263V507.111H295.399V546.939V546.939ZM317.996 529.098C317.996 539.676 325.753 547.786 336.965 547.786C341.901 547.786 347.331 545.881 350.786 542.708L347.895 537.702C345.074 540.24 341.195 541.862 337.387 541.862C330.971 541.862 325.47 537.702 325.118 530.015H351.068C351.209 529.028 351.35 528.041 351.35 527.124C351.35 517.958 345.991 510.412 335.907 510.412C325.753 510.412 317.996 517.746 317.996 529.098V529.098ZM325.33 525.079C326.316 519.156 330.477 515.701 335.766 515.701C340.42 515.701 344.228 518.944 344.439 525.079H325.33ZM356.953 547.291C367.46 546.728 371.55 538.406 371.55 522.258V516.899H382.057V546.939H388.897V511.258H364.992V522.258C364.992 535.163 362.172 540.381 356.953 541.157V547.291V547.291ZM398.378 529.098C398.378 539.676 406.135 547.786 417.347 547.786C422.283 547.786 427.713 545.881 431.168 542.708L428.277 537.702C425.456 540.24 421.578 541.862 417.77 541.862C411.353 541.862 405.853 537.702 405.5 530.015H431.45C431.591 529.028 431.732 528.041 431.732 527.124C431.732 517.958 426.373 510.412 416.289 510.412C406.135 510.412 398.378 517.746 398.378 529.098V529.098ZM405.712 525.079C406.699 519.156 410.86 515.701 416.148 515.701C420.802 515.701 424.61 518.944 424.821 525.079H405.712ZM441.214 546.939H448.054V531.497H453.202L463.849 546.939H471.959L458.631 528.393V528.253L470.548 511.258H462.791L453.06 525.644H448.054V511.258H441.214V546.939V546.939ZM475.446 529.028C475.446 539.887 484.049 547.786 494.697 547.786C505.274 547.786 513.877 539.887 513.877 529.028C513.877 518.239 505.274 510.412 494.627 510.412C484.049 510.412 475.446 518.239 475.446 529.028ZM482.427 529.028C482.427 521.624 487.927 516.335 494.697 516.335C501.396 516.335 506.967 521.624 506.967 529.028C506.967 536.503 501.396 541.862 494.697 541.862C487.927 541.862 482.427 536.503 482.427 529.028ZM521.878 546.939H528.507L530.058 525.713C530.199 523.598 529.988 519.579 529.988 519.579H530.128C530.128 519.579 531.256 522.258 532.385 524.867L540.847 542.637H546.7L555.162 524.797C556.501 522.047 557.418 519.579 557.418 519.579H557.559C557.559 519.579 557.418 523.598 557.488 525.713L559.04 546.939H565.669L562.565 511.258H555.091L545.783 531.426C544.866 533.611 543.808 536.22 543.808 536.22H543.668C543.668 536.22 542.68 533.541 541.693 531.426L532.597 511.258H524.981L521.878 546.939V546.939Z" fill="#2B2A29"/>
                <path d="M91.88 546.947C90.677 546.447 89.5416 545.769 88.5262 545.058L88.1056 544.763L90.1976 541.669L90.7531 542.051C91.7952 542.769 93.7381 544.109 95.7312 544.109C97.2213 544.109 98.2625 543.477 99.1147 542.353C99.9982 541.185 100.463 540.058 101.236 537.995L82.8286 501.047H87.1523L100.956 528.785C101.804 530.485 102.648 532.442 103.148 533.637C103.56 532.449 104.236 530.523 104.869 528.836L115.306 501.047H119.512L104.241 540.477C103.427 542.552 102.384 544.359 101.015 545.658C99.6122 546.99 97.8836 547.785 95.7312 547.785C94.4082 547.785 93.1072 547.456 91.88 546.947V546.947ZM131.932 546.949V501.047H156.198V504.722H135.805V546.949H131.932ZM229.133 546.949H225.782V501.047H229.654V520.381H237.4L249.794 501.047H254.447L240.694 522.157L256.121 546.949H251.47L237.393 524.057H229.654V546.949H229.133V546.949ZM163.778 546.949C164.993 531.648 166.217 516.346 167.451 501.047H171.028L184.589 530.296C185.256 531.717 185.977 533.426 186.418 534.492C186.857 533.425 187.577 531.717 188.247 530.296L201.808 501.047H205.383L209.057 546.949H205.18L202.409 512.534C202.318 511.497 202.268 510.118 202.242 508.927C201.785 510.159 201.213 511.626 200.703 512.711L188.195 539.259H184.641C182.039 533.71 174.968 516.588 172.194 512.703C171.695 511.606 171.083 510.039 170.596 508.743C170.57 509.992 170.52 511.461 170.426 512.534L167.655 546.949H163.778V546.949Z" fill="#2B2A29"/>
                <path d="M277.298 521.515H267.118V531.695H277.298V521.515Z" fill="#2B2A29"/>
                <path d="M178.588 286.221H142.534V321.997H178.588V286.221Z" fill="#F9B101"/>
                <path d="M214.642 143.116H178.588V178.892H214.642V143.116Z" fill="#1FB6EA"/>
                <path d="M214.642 286.221H178.588V321.997H214.642V286.221Z" fill="#F18917"/>
                <path d="M250.696 143.116H214.642V178.892H250.696V143.116Z" fill="#008DD2"/>
                <path d="M250.696 286.221H214.642V321.997H250.696V286.221Z" fill="#E85222"/>
                <path d="M286.75 143.116H250.696V178.892H286.75V143.116Z" fill="#0C54A0"/>
                <path d="M286.75 286.221H250.696V321.997H286.75V286.221Z" fill="#E31E24"/>
                <path d="M322.808 143.116H286.753V178.892H322.808V143.116Z" fill="#2B2A29"/>
                <path d="M322.808 214.669H286.753V250.445H322.808V214.669Z" fill="#2B2A29"/>
                <path d="M322.808 250.443H286.753V286.219H322.808V250.443Z" fill="#2B2A29"/>
                <path d="M358.862 71.564H322.808V107.34H358.862V71.564Z" fill="#1FB6EA"/>
                <path d="M358.862 107.338H322.808V143.114H358.862V107.338Z" fill="#0C54A0"/>
                <path d="M358.862 178.891H322.808V214.667H358.862V178.891Z" fill="#2B2A29"/>
                <path d="M358.862 286.221H322.808V321.997H358.862V286.221Z" fill="#E31E24"/>
                <path d="M358.862 321.996H322.808V357.772H358.862V321.996Z" fill="#E85222"/>
                <path d="M358.862 357.773H322.808V393.549H358.862V357.773Z" fill="#F18917"/>
                <path d="M358.862 393.548H322.808V429.324H358.862V393.548Z" fill="#F9B101"/>
                <path d="M394.916 178.891H358.861V214.667H394.916V178.891Z" fill="#0C54A0"/>
                <path d="M430.97 178.891H394.916V214.667H430.97V178.891Z" fill="#008DD2"/>
                <path d="M467.024 178.891H430.97V214.667H467.024V178.891Z" fill="#1FB6EA"/>
            </svg>
        </Box>
    )
}
const Content = (notification) => {
    return (
        <Box flex="1" justifyContent="center" alignItems="center" display="flex">
            <img
                src={getUrlForImageMobileUrl(notification?.payload?.report?.images?.main)}
                style={{maxHeight: '100%', height: '100%', objectFit: 'contain'}}
            />
        </Box>
    )
}

export default DialogImageNotification;
